import { BrowserRouter, Route, Routes } from "react-router-dom";

import { AppShell } from "./AppShell.js";
import { LibraryPage } from "../library/LibraryPage.js";
import { ReadinessPage } from "../readiness/ReadinessPage.js";
import { ContactDirectoryPage } from "../contacts/ContactDirectoryPage.js";
import {
  EmergencyPage,
  DisasterHubPage,
  AboutPage,
  FamilyPlanPage,
  HomePage,
  LearningPage,
  LearningTopicPage,
  OutdoorEnvironmentPage,
  NotFoundPage,
  SettingsPage,
} from "./pages.js";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<AppShell />}>
          <Route element={<HomePage />} index />
          <Route element={<EmergencyPage />} path="emergency" />
          <Route element={<LearningPage />} path="learn" />
          <Route element={<LearningTopicPage />} path="learn/:topic" />
          <Route element={<OutdoorEnvironmentPage />} path="learn/outdoors/:environment" />
          <Route element={<DisasterHubPage />} path="disaster" />
          <Route element={<LibraryPage />} path="search" />
          <Route element={<ContactDirectoryPage />} path="contacts" />
          <Route element={<FamilyPlanPage />} path="family-plan" />
          <Route element={<ReadinessPage />} path="readiness" />
          <Route element={<SettingsPage />} path="settings" />
          <Route element={<AboutPage />} path="about" />
          <Route element={<NotFoundPage />} path="*" />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
